module.exports = __webpack_public_path__ + "static/media/excel.237797d2.svg";